import * as Yup from "yup";
import {
  AudioComment,
  Project,
  Share,
  ShareWithAnalyticsEvent,
  Track,
  TrackFileType,
  User,
  VersionState,
} from "../../proto/api_pb";
import { Dispatch, SetStateAction } from "react";
import { TrackObj, TrackVersionsObj } from "../../pages/MyTracks/types";
import { FolderUploadInfo, UploadCardStatusInfo, UploadedFileInfo } from "../FileUploadStatusCard/types";

export const newTrack = {
  artist: "",
  hasSong: undefined,
  coverArtUpload: undefined,
  genres: "",
  album: "",
  newCollaborator: {
    username: "",
  },
};

export interface SplitSheetProps {
  handleTrackMenuClose: () => void;
  track: TrackObj;
  isPublishingSplitSheetDetails?: boolean;
}

export const TRACK_VALIDATION_SCHEMA = Yup.object().shape({
  fileLabel: Yup.string().optional(),
  fileUpload: Yup.mixed().required("required"),
  bpm: Yup.number()
    .min(0, "Amount must be greater than 0")
    .max(200, "Amount must be less than 200"),
  newCollaborator: Yup.mixed().optional(),
});

export const newAddTrack = {
  fileUpload: undefined,
  fileLabel: "",
  bpm: 0,
  newCollaborator: {
    username: "",
  },
};

export const fileTypes = [
  {
    option: "Specify the file type",
    value: TrackFileType.TRACK_FILE_TYPE_UNSPECIFIED,
  },
  {
    option: "Session",
    value: TrackFileType.TRACK_FILE_TYPE_SESSION,
  },
  {
    option: "Stem Vocal",
    value: TrackFileType.TRACK_FILE_TYPE_STEM_VOCAL,
  },
  {
    option: "Stem Drum",
    value: TrackFileType.TRACK_FILE_TYPE_STEM_DRUM,
  },
  {
    option: "Stem Melody",
    value: TrackFileType.TRACK_FILE_TYPE_STEM_MELODY,
  },
  {
    option: "Stem Instrument",
    value: TrackFileType.TRACK_FILE_TYPE_STEM_INSTRUMENT,
  },
  {
    option: "Stem Bassline",
    value: TrackFileType.TRACK_FILE_TYPE_STEM_BASSLINE,
  },
  {
    option: "Lyrics",
    value: TrackFileType.TRACK_FILE_TYPE_LYRICS,
  },
  {
    option: "Artwork",
    value: TrackFileType.TRACK_FILE_TYPE_ARTWORK,
  },
  {
    option: "Other",
    value: TrackFileType.TRACK_FILE_TYPE_OTHER,
  },
];

export const versionStates = [
  {
    option: "Specify the version state",
    value: VersionState.VERSION_STATE_UNSPECIFIED,
  },
  {
    option: "Ready for Recording",
    value: VersionState.VERSION_STATE_READY_FOR_RECORDING,
  },
  {
    option: "Ready for Mastering",
    value: VersionState.VERSION_STATE_READY_FOR_MASTERING,
  },
  {
    option: "Ready for Mixing",
    value: VersionState.VERSION_STATE_READY_FOR_MIXING,
  },
  {
    option: "Ready for Publishing",
    value: VersionState.VERSION_STATE_READY_FOR_PUBLISHING,
  },
  {
    option: "Completed",
    value: VersionState.VERSION_STATE_COMPLETED,
  },
];

export interface SendInviteModalProps {
  isSendInviteModalOpen: boolean;
  setIsSendInviteModalOpen: Dispatch<SetStateAction<boolean>>;
  userId: string;
}
export interface ShareDetailsModalProps {
  isShareDetailsModalOpen: boolean;
  setIsShareDetailsModalOpen: Dispatch<SetStateAction<boolean>>;
  id: string | undefined;
  title: string | undefined;
  shareType: number;
  shareForUpdate?: Share | undefined;
  isUpdateModal?: boolean;
  getSharesList?: () => Promise<void>;
}

export interface ShareModalProps {
  id: string;
  title: string;
  shareType: number;
}


export interface AddTrackVersionModalPros {
  open?: boolean;
  handleTrackMenuClose: () => void;
  handleCloseModal?: () => void;
  track: Track | undefined;
  handleRefreshTracks: () => Promise<void>;
  isAccordionDetailsButton?: boolean;
  allVersions?: TrackVersionsObj[];
  selectedTrackLatestVersion?: number;
}

export interface AddProjectModalProps {
  enterpriseUsers: User[];
  handleUseEffect: () => Promise<void>;
  setProjects: Dispatch<SetStateAction<Project[]>>;
  projects: Project[]
  setPage: Dispatch<SetStateAction<number>>;
}

export interface AddItemsModalProps {
  setUploadingFilesDetailsList: Dispatch<SetStateAction<UploadedFileInfo[]>>;
  setIsUploading: Dispatch<SetStateAction<boolean>>;
  setUploadingCardsStatusList: Dispatch<SetStateAction<UploadCardStatusInfo[]>>;
  setIsUploadProcessing: Dispatch<SetStateAction<boolean>>;
  setFolderUploadInfo: Dispatch<SetStateAction<FolderUploadInfo | undefined>>;
  getAllFoldersForProject: () => Promise<void>
  setIsFilesUpdated: Dispatch<SetStateAction<boolean>>
  setIsCountUpdated: Dispatch<SetStateAction<boolean>>;
  getStorageUsed: () => Promise<void>
}

export interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedShareForAnalytics: ShareWithAnalyticsEvent | undefined;
}


export interface TrackCommentsProps {
  allComment: AudioComment | undefined;
}

export interface FolderUploadProps {
  setIsUploading: (isUploading: boolean) => void;
  handleCloseBatchTrackAddModal: () => void;
  setIsUploadProcessing: (isProcessing: boolean) => void;
  setFolderUploadInfo: React.Dispatch<
    React.SetStateAction<FolderUploadInfo | undefined>
  >;
  handleOpenMessageModal: () => void;
  getStorageUsed: () => Promise<void>;
}